// 社員マスタ(workers = B@社員マスタ)のレコードから、アプリ上で表示・保存する氏名を決める。
//
// 姓が変わって旧姓を「職場氏名」(B178_sname)として登録している社員は、
// アプリ上では職場氏名を使う、というのが業務上の仕様。
// 職場氏名が空の社員は通常氏名(B178_name)にフォールバックする。
//
// このルールは2025-05-14に導入されたが、当時は3つある発注担当者のセット経路のうち
// 1経路にしか適用されておらず、社員番号検索とサインイン時のusers doc自動生成では
// 通常氏名がそのまま使われていた(2026-08の問い合わせ)。同じ取りこぼしを防ぐため、
// 氏名の解決は必ずこの関数を通すこと。
//
// firebaseに依存しない純関数なのでJestで直接テストできる。
//
// 注: フィールドが欠落したレコードでも例外を投げないこと。
//     サインイン処理の中で使われるため、ここで throw するとログイン不能になる。
export const resolveWorkerName = (worker) =>
  worker?.B178_sname?.value || worker?.B178_name?.value || "";

export default resolveWorkerName;
